import {
  InAppMessage,
  DecisionReason,
  HackleEvent,
  HackleUser,
  InAppMessageContextMessage,
  Properties
} from "../../../../core/internal/model/model"
import { InAppMessagePresentRequest } from "../InAppMessagePresentRequest"

export class InAppMessagePresentationContext {
  constructor(
    public readonly dispatchId: String,
    public readonly inAppMessage: InAppMessage,
    public readonly message: InAppMessageContextMessage,
    public readonly user: HackleUser,
    public readonly decisionReason: DecisionReason,
    public readonly properties: Properties,
    public readonly triggerEvent: HackleEvent
  ) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessagePresentationContext(dispatchId=${this.dispatchId}, inAppMessage=${this.inAppMessage}, message=${this.message}, triggerEvent=${this.triggerEvent.key})`
  }

  static of(request: InAppMessagePresentRequest): InAppMessagePresentationContext {
    return new InAppMessagePresentationContext(
      request.dispatchId,
      request.inAppMessage,
      request.message,
      request.user,
      request.reason,
      request.properties,
      request.triggerEvent
    )
  }
}
